<template>
    <!-- RADIO/SELECT SLOT -->
    <div>
        <RadioSelectLink
            v-model="form.displayMode"
            :options="options"
            :radioSelected="cardCustomSettings.displayMode"
            @updateSelect="updateSelect"
            @updateRadio="updateRadio"
        />
        <!-- SELECT CALENDARS -->
        <template v-if="cardSettings.provider !== 'sellsy'">
            <p class="semibold mb-1 mt-3">{{ $l10n.__('Calendriers') }}</p>
            <el-form-item prop="calendars">
                <template #label>
                    <p class="grey mb-1">
                        {{ $l10n.__('Sélectionnez les calendriers que vous souhaitez afficher.') }}
                    </p>
                </template>
                <el-checkbox-group
                    v-model="form.calendars"
                    class="wp-5 flex-level flex-column h-160"
                >
                    <el-checkbox
                        v-for="calendar in cardSettings.calendars"
                        :key="calendar.id"
                        :label="calendar.id"
                        class="calendar-settings-checkbox"
                        :style="{ color: calendar.backgroundColor }"
                    >
                        {{ calendar.name }}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </template>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import RadioSelectLink from '../../utilities/RadioSelectLink.vue';

export default {
    components: {
        RadioSelectLink,
    },
    mixins: [SettingsFormMixin],
    data() {
        const checkCalendars = (rule, value, callback) => {
            if (value.length >= 1 && value.length <= 5) {
                callback();
            } else {
                callback(
                    new Error(this.$l10n.__('Veuillez sélectionner entre 1 et 5 calendriers')),
                );
            }
        };
        return {
            agendaRules: {
                displayMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
                calendars: [{ validator: checkCalendars, trigger: 'change' }],
            },
            options: {
                title: this.$l10n.__('Mode d’affichage'),
                items: {
                    0: {
                        titleRadio: this.$l10n.__('Afficher les événements des prochains jours'),
                        label: 'days',
                        data: this.form.nbDays,
                        selectData: [
                            {
                                label: this.$l10n.__('7 jours'),
                                value: 7,
                            },
                            {
                                label: this.$l10n.__('15 jours'),
                                value: 14,
                            },
                        ],
                    },
                    1: {
                        titleRadio: this.$l10n.__('Afficher les prochains événements'),
                        label: 'events',
                        data: this.form.nbEvents,
                        selectData: [
                            {
                                label: this.$l10n.__('10 événements'),
                                value: 10,
                            },
                            {
                                label: this.$l10n.__('25 événements'),
                                value: 25,
                            },
                        ],
                    },
                },
            },
        };
    },
    mounted() {
        this.$emit('set-rules', this.agendaRules);
    },
    methods: {
        updateRadio(data) {
            this.form.displayMode = data.radio;
        },
        updateSelect(data) {
            switch (this.form.displayMode) {
                case 'days':
                    this.form.nbDays = data.select;
                    break;
                case 'events':
                    this.form.nbEvents = data.select;
                    break;
            }
        },
        close() {
            this.$emit('close-form');
        },
    },
};
</script>

<style lang="scss">
.calendar-settings-checkbox.el-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
    color: inherit;
}
</style>
